import { CSSProperties } from 'react';
import styled from 'styled-components';

import { Typography, TypographyProps } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CustomCheckbox = styled.div`
  .checkbox {
    width: 20px;
    height: 20px;
    border-radius: 8px;
    border: 1px solid ${COLOR.neutralTrans['neutralTrans-25']};
    background: ${COLOR.neutral['neutral-1']};
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .active {
    .checkbox {
      background-color: #fd8a24;
      border: 1px solid transparent;
    }
  }
`;

export const ThumbnailContainer = styled.div<{ $bgImg: string; $bgColor: string }>`
  position: relative;
  margin-bottom: 12px;
  width: 100%;
  height: 184px;
  border-radius: 12px;
  background: ${(props) => `url(${props.$bgImg}) ${props.$bgColor} center / contain no-repeat`};
  border: 1px solid rgba(0, 0, 0, 0.06);

  @media (min-width: 996px) {
    background: ${(props) => `url(${props.$bgImg}) ${props.$bgColor} center / cover no-repeat`};
  }
`;

export const TagContainer = styled.div`
  display: flex;
  gap: 6px;
  position: absolute;
  bottom: 10px;
  left: 10px;

  p {
    font-weight: 400;
    color: ${COLOR_CONFIG.white};
    font-size: 12px;
    line-height: calc(16 / 12);
  }
`;

export const CustomTypography = styled.div`
  background: rgba(46, 44, 44, 0.7);
  border-radius: 6px;
  padding: 1px 8px 2px 8px;
  backdrop-filter: blur(2px);
  font-weight: 400;
  color: ${COLOR_CONFIG.white};
  font-size: 12px;
  line-height: calc(16 / 12);
`;

export const CardType = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: calc(20 / 14);
  color: ${COLOR_CONFIG['neutral-text']};
`;

export const SubTitleStyle = styled(CardType).attrs({ as: 'span' })<TypographyProps>``;

export const TagComponentStyle: CSSProperties = {
  fontSize: 14,
  lineHeight: 'calc(20/14)',
  position: 'absolute',
  bottom: 10,
  left: 10,
  border: `1px solid ${COLOR.primary['primary-3']}`,
  background: COLOR.primary['primary-1'],
  borderRadius: 999,
  padding: '2px 10px 3px 10px',
};

export const CardName = styled(Typography)`
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
`;
